"use strict";

import { Helper } from "../helpers/helperFunctions.js";

Number.prototype.getHH = function() {
    return Math.floor(this / 3600);
}
Number.prototype.getMM = function(hours) {
    return Math.floor((this - (hours * 3600)) / 60);
}
Number.prototype.getSS = function(hours,minutes) {
    return this - (hours * 3600) - (minutes * 60);
}
Number.prototype.getMS = function(seconds) {
    return ((seconds - Math.floor(seconds)) * 100).fixPrecision(0);
}

Number.prototype.toHHMMSS = function() {
    let hours   = this.getHH();
    let minutes = this.getMM(hours);
    let seconds = this.getSS(hours, minutes).fixPrecision(0);

    if (hours   < 10) { hours   = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ":" + minutes + ":" + seconds;
}
String.prototype.toHHMMSS = function() {
    return parseInt(this, 10).toHHMMSS();
}

Number.prototype.toMMSS = function() {
    let hours   = this.getHH();
    let minutes = this.getMM(hours);
    let seconds = this.getSS(hours, minutes).fixPrecision(0);

    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return minutes + ":" + seconds;
}
String.prototype.toMMSS = function() {
    return parseInt(this, 10).toMMSS();
}

Number.prototype.toSS = function() {
    let hours   = this.getHH();
    let seconds = this.getSS(hours, this.getMM(hours)).fixPrecision(0);

    if (seconds < 10) { seconds = "0" + seconds; }
    return seconds.toString();
}
String.prototype.toSS = function() {
    return parseInt(this, 10).toSS();
}

Number.prototype.toSSMS = function() {
    let hours   = this.getHH();
    let seconds = this.getSS(hours, this.getMM(hours));
    let milliseconds = this.getMS(seconds);
    seconds = seconds.fixPrecision(0);

    if (seconds < 10) { seconds = "0" + seconds; }
    if (milliseconds > 99) { milliseconds = 99; }
    if (milliseconds < 10) { milliseconds = "0" + milliseconds; }
    return seconds + ":" + milliseconds;
}
String.prototype.toSSMS = function() {
    return parseInt(this, 10).toSSMS();
}

Number.prototype.toMS = function() {
    let hours = this.getHH();
    let milliseconds = this.getMS(this.getSS(hours, this.getMM(hours)));

    if (milliseconds < 10) { milliseconds = "0" + milliseconds; }
    return milliseconds.toString();
}
String.prototype.toMS = function() {
    return parseInt(this, 10).toMS();
}

Number.prototype.addLeadingZeros = function(zeros) {
    let str = this.toString();
    for (let i = 0; i < zeros; i++) {
        str = "0" + str;
    }
    return str.slice(-(zeros + 1));
}

Number.prototype.fixPrecision = function(precision = 4) {
    if (this == 0) return this;
    return parseFloat(this.toFixed(precision));
}